import React, { useState, FC } from "react";
import baseApi from "utils/axios-instance";
import { Mixpanel } from "utils/Analytics";
import { Loader2, Phone } from "lucide-react";
import { Button } from "components/ui/button";
import { Toaster } from "components/ui/sonner";
import { toast } from "sonner";

const PatientCallsPage: FC = () => {
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleInterestClick = async () => {
    if (submitting || submitted) {
      return;
    }
    setSubmitting(true);
    Mixpanel.track("Patient Calls Interest Clicked");
    try {
      await baseApi.post("/dashboard/patient-calls/interest");
      setSubmitted(true);
      toast.success("Thanks — we'll be in touch soon.");
    } catch (error: any) {
      const message =
        error?.response?.data?.detail ||
        "Something went wrong. Please email support@healthharbor.co.";
      toast.error(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="px-6 py-10 max-w-2xl mx-auto">
      <Toaster />
      <div className="flex flex-col items-start gap-6">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-brand/10 text-brand">
            <Phone className="h-5 w-5" />
          </div>
          <h1 className="text-2xl font-semibold text-gray-900">Patient Calls</h1>
        </div>

        <p className="text-base leading-relaxed text-gray-700">
          Patient calls aren&apos;t enabled for your team yet. If you&apos;re
          interested in having AI call your patients for follow-ups, reminders,
          or off-hours/weekend calling, let us know.
        </p>

        <Button
          onClick={handleInterestClick}
          disabled={submitting || submitted}
          className="bg-brand hover:bg-brand-hover text-white"
        >
          {submitting ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Sending…
            </>
          ) : submitted ? (
            "Interest sent"
          ) : (
            "Let us know"
          )}
        </Button>
      </div>
    </div>
  );
};

export default PatientCallsPage;
